// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Graphics, Text, NineSlicePlane } from 'pixi.js';
import { ButtonLargeLayout } from '../common/buttons/ButtonLargeLayout';

const raw = {
  list: [
    {
      id: 'c1f69745-29bf-4c85-b95e-4b629733fe3f',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: 'e7f5099d-33a0-4ae6-99da-a32bad36793c',
      type: 'Sprite',
      name: 'gradient',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 15.6,
        y: 2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'WinStreak_Blue_Gradient',
      parent: 'c1f69745-29bf-4c85-b95e-4b629733fe3f'
    },
    {
      id: '662f350d-dd79-47fe-827a-5bc350967c87',
      type: 'Container',
      name: 'contentWrapper',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'c1f69745-29bf-4c85-b95e-4b629733fe3f'
    },
    {
      id: 'b37caf83-11aa-4b33-aada-27571b6808b5',
      type: 'Graphics',
      name: 'backgroundOverlay',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '662f350d-dd79-47fe-827a-5bc350967c87',
      commands: [
        {
          id: 'cca91f03-9958-40ee-b99c-9c53f9078fe3',
          type: 'beginFill',
          color: 16442515,
          alpha: 1
        },
        {
          id: '807bf179-6e9d-441e-9cf2-e627f10cde25',
          type: 'drawRect',
          x: -2000,
          y: -2000,
          width: 4000,
          height: 4000
        },
        {
          id: 'cfc66c49-ca9d-4fd1-a830-b09c7f96dc5c',
          type: 'beginFill',
          color: 16442515,
          alpha: 1
        }
      ]
    },
    {
      id: '851bda6e-f8b9-48ff-8a3d-2cf0920c321a',
      type: 'Sprite',
      name: 'background',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Background',
      parent: '662f350d-dd79-47fe-827a-5bc350967c87'
    },
    {
      id: '8ff3c5ec-b94a-4da6-b5db-b127e3e622a3',
      type: 'Sprite',
      name: 'rays',
      className: '',
      x: 0,
      y: 80,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Yellow_Rays',
      parent: '662f350d-dd79-47fe-827a-5bc350967c87'
    },
    {
      id: '48a19cea-a907-4e7a-b523-0202bdb93829',
      type: 'Sprite',
      name: 'flag',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Flag',
      parent: '662f350d-dd79-47fe-827a-5bc350967c87'
    },
    {
      id: '8f8b8c9b-11cf-4b20-b923-8a6a39fcebb0',
      type: 'Container',
      name: 'header',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '662f350d-dd79-47fe-827a-5bc350967c87'
    },
    {
      id: '3046cb36-e606-4039-9d9a-51e93ff775dc',
      type: 'Container',
      name: 'popup',
      className: '',
      x: 0,
      y: 740,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '662f350d-dd79-47fe-827a-5bc350967c87'
    },
    {
      id: '1fc61b95-d779-4313-a393-d7708253e84a',
      type: 'Container',
      name: 'tutorialSlot',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 0,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '662f350d-dd79-47fe-827a-5bc350967c87'
    },
    {
      id: 'f648d286-467e-4836-89c8-97a7146b82b0',
      type: 'Sprite',
      name: 'winStreakLogo',
      className: '',
      x: 15,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.87,
        y: 0.87
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Logo',
      parent: '48a19cea-a907-4e7a-b523-0202bdb93829'
    },
    {
      id: '3692dadb-3926-4557-9d61-7394bf31462e',
      type: 'Sprite',
      name: 'helpButton',
      className: '',
      x: -325,
      y: 65,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'Help',
      parent: '8f8b8c9b-11cf-4b20-b923-8a6a39fcebb0'
    },
    {
      id: '0441bead-2e28-44a2-b673-c403291c6dac',
      type: 'Sprite',
      name: 'closeButton',
      className: '',
      x: 325,
      y: 65,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'Shop_Close_Button',
      parent: '8f8b8c9b-11cf-4b20-b923-8a6a39fcebb0'
    },
    {
      id: 'f43b5f8f-7813-4d3a-9837-7cfe6fc09a56',
      type: 'Sprite',
      name: 'eventTextBackgroundColor',
      className: '',
      x: 0,
      y: 209,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 2.68,
        y: 0.6
      },
      angle: 0,
      alpha: 0.7,
      visible: true,
      tint: 558902,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Circle_Glow',
      parent: '8f8b8c9b-11cf-4b20-b923-8a6a39fcebb0'
    },
    {
      id: '26bf8dfb-acea-4363-ba71-417ac95ab522',
      type: 'Sprite',
      name: 'timerBackground',
      className: '',
      x: 14,
      y: 143,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Timer_Background',
      parent: '8f8b8c9b-11cf-4b20-b923-8a6a39fcebb0'
    },
    {
      id: '400e13c6-d516-4f35-af25-829b4c923236',
      type: 'Text',
      name: 'eventDescription',
      className: '',
      x: 0,
      y: 210,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Win matches without losing to reach new reward goals!',
      localize: true,
      maxWidth: 460,
      maxHeight: 77,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#46130b',
        strokeThickness: 6,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 460,
        breakWords: false,
        lineHeight: 24,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '8f8b8c9b-11cf-4b20-b923-8a6a39fcebb0'
    },
    {
      id: 'e99b6306-d667-432a-b316-3c0ab86b9fbf',
      type: 'Sprite',
      name: 'grass',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Grass',
      parent: '3046cb36-e606-4039-9d9a-51e93ff775dc'
    },
    {
      id: 'fedddb3b-5004-4991-9185-aea4372260c7',
      type: 'Sprite',
      name: 'scrollViewInput',
      className: '',
      x: 0,
      y: -70,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: false,
      hitArea: {
        type: 'Rectangle',
        x: -330,
        y: -350,
        width: 660,
        height: 868
      },
      texture: '',
      parent: '3046cb36-e606-4039-9d9a-51e93ff775dc'
    },
    {
      id: 'c53149cd-638b-4c88-9f41-3667562179cc',
      type: 'Container',
      name: 'mapSlot',
      className: '',
      x: 0,
      y: 462,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '3046cb36-e606-4039-9d9a-51e93ff775dc'
    },
    {
      id: '155bfd10-2110-4d22-95df-8b6c7d902cbc',
      type: 'Graphics',
      name: 'mapSlotMask',
      className: '',
      x: -348,
      y: -456,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '3046cb36-e606-4039-9d9a-51e93ff775dc',
      commands: [
        {
          id: '81d8b890-1c65-486f-80e5-8385b3469c62',
          type: 'beginFill',
          color: 16777215,
          alpha: 1
        },
        {
          id: 'c170d404-52bd-4f84-aa0f-f8750cc3accc',
          type: 'drawRoundedRect',
          x: 0,
          y: 0,
          width: 690,
          height: 910,
          radius: 70
        },
        {
          id: '1f977565-37b8-49a4-9d05-047ab5b56448',
          type: 'beginFill',
          color: 16777215,
          alpha: 1
        }
      ]
    },
    {
      id: 'ee6aca07-353f-4515-ba43-f7283baa1195',
      type: 'NineSlicePlane',
      name: 'roadFrame',
      className: '',
      x: -357,
      y: -465,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 707,
      height: 932,
      leftWidth: 84,
      topHeight: 82,
      rightWidth: 84,
      bottomHeight: 82,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Road_Frame_9slice_82_84_82_84',
      parent: '3046cb36-e606-4039-9d9a-51e93ff775dc'
    },
    {
      id: 'd71ee65c-4d56-4075-bfbb-960f947d533e',
      type: 'Layout',
      name: 'playButton',
      className: '',
      path: 'common/buttons/ButtonLargeLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: 455,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      parent: '3046cb36-e606-4039-9d9a-51e93ff775dc',
      data: {
        color: 'green',
        tapSound: 'UI_Button_Click'
      }
    },
    {
      id: 'b31c4662-be23-4783-ab04-06125825b346',
      type: 'Container',
      name: 'progressBar',
      className: '',
      x: 0,
      y: -445,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '3046cb36-e606-4039-9d9a-51e93ff775dc'
    },
    {
      id: 'abfc9cc9-c823-43d0-8037-563c9c40f89e',
      type: 'Sprite',
      name: 'timer',
      className: '',
      x: -96,
      y: -1,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.84,
        y: 0.84
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Golden_Clock',
      parent: '26bf8dfb-acea-4363-ba71-417ac95ab522'
    },
    {
      id: '60fbe96b-bc47-45dc-bd62-70f3d29d3c0d',
      type: 'Text',
      name: 'timerText',
      className: '',
      x: 0,
      y: -1,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 0.84,
        y: 0.84
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '1d 12h',
      localize: false,
      maxWidth: 150,
      maxHeight: 40,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 36,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#870066',
        strokeThickness: 0,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '26bf8dfb-acea-4363-ba71-417ac95ab522'
    },
    {
      id: 'a73eba86-8293-4ca3-a2d3-e1c4a1122a1c',
      type: 'Text',
      name: 'playText',
      className: '',
      x: 0,
      y: -23,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Play',
      localize: true,
      maxWidth: 294,
      maxHeight: 104,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 47,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#e9ffe6',
        stroke: '#016f10',
        strokeThickness: 8,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'd71ee65c-4d56-4075-bfbb-960f947d533e'
    },
    {
      id: '0cf7dba3-1ec8-463e-ade7-2fc803ff8a60',
      type: 'Text',
      name: 'playButtonLevelText',
      className: '',
      x: 0,
      y: 18,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'LEVEL 20',
      localize: false,
      maxWidth: 294,
      maxHeight: 104,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#e9ffe6',
        stroke: '#016f10',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'd71ee65c-4d56-4075-bfbb-960f947d533e'
    },
    {
      id: 'de7f303d-c50a-4aba-aa67-8c6ccce8593f',
      type: 'Sprite',
      name: 'progressBarBack',
      className: '',
      x: 0,
      y: -6,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'WinStreak_Progress_Bar_Background',
      parent: 'b31c4662-be23-4783-ab04-06125825b346'
    },
    {
      id: '9781e102-0b73-46d6-9f99-e69a7b00985a',
      type: 'Sprite',
      name: 'progressBarFill',
      className: '',
      x: -187,
      y: -28,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'WinStreak_Progress_Bar_Full',
      parent: 'b31c4662-be23-4783-ab04-06125825b346'
    },
    {
      id: '15c564c2-116e-4907-b3f3-0833bcc179b2',
      type: 'Sprite',
      name: 'progressBarTop',
      className: '',
      x: 0,
      y: -6,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'WinStreak_Progress_Bar_Top',
      parent: 'b31c4662-be23-4783-ab04-06125825b346'
    },
    {
      id: 'a66dfb92-4e7e-4de0-a89f-0f28feff8895',
      type: 'Sprite',
      name: 'progressBarChest',
      className: '',
      x: 196,
      y: -9,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Chest_Closed',
      parent: 'b31c4662-be23-4783-ab04-06125825b346'
    }
  ],
  x: 0,
  y: 0,
  width: 780,
  height: 1280,
  version: '2.0.0',
  handleResize: false
} as const;

export class WinStreakRoadPopupLayout {
  static raw = raw;
  root!: Container;
  gradient!: Sprite;
  contentWrapper!: Container;
  backgroundOverlay!: Graphics;
  background!: Sprite;
  rays!: Sprite;
  flag!: Sprite;
  header!: Container;
  popup!: Container;
  tutorialSlot!: Container;
  winStreakLogo!: Sprite;
  helpButton!: Sprite;
  closeButton!: Sprite;
  eventTextBackgroundColor!: Sprite;
  timerBackground!: Sprite;
  eventDescription!: Text;
  grass!: Sprite;
  scrollViewInput!: Sprite;
  mapSlot!: Container;
  mapSlotMask!: Graphics;
  roadFrame!: NineSlicePlane;
  playButton!: ButtonLargeLayout & { data: typeof raw['list'][21]['data'] };
  progressBar!: Container;
  timer!: Sprite;
  timerText!: Text;
  playText!: Text;
  playButtonLevelText!: Text;
  progressBarBack!: Sprite;
  progressBarFill!: Sprite;
  progressBarTop!: Sprite;
  progressBarChest!: Sprite;
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}
